import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';
import { LocalizedOpenGraphMetadataEntrySchema, OpenGraphMetadataEntrySchema } from './open-graph-metadata.validator';
import { filterUnresolvedLink } from './preprocessors';
import { LocalizedTwitterMetadataEntrySchema, TwitterMetadataEntrySchema } from './twitter-metadata.validator';

export const SeoMetadataEntrySchema = z.looseObject({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.string(),
    title: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    keywords: z.array(z.string()).optional().nullable(),
    twitter: z.preprocess(filterUnresolvedLink, TwitterMetadataEntrySchema.optional().nullable()).optional().nullable(),
    openGraph: z.preprocess(filterUnresolvedLink, OpenGraphMetadataEntrySchema.optional().nullable()).optional().nullable(),
    noIndex: z.boolean().optional().nullable(),
    noFollow: z.boolean().optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export const LocalizedSeoMetadataEntrySchema = z.looseObject({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.record(z.string(), z.string()),
    title: z.record(z.string(), z.string().optional().nullable()).optional().nullable(),
    description: z.record(z.string(), z.string().optional().nullable()).optional().nullable(),
    keywords: z.record(z.string(), z.array(z.string()).optional().nullable()).optional().nullable(),
    twitter: z.record(z.string(), LocalizedTwitterMetadataEntrySchema.optional().nullable()).optional().nullable(),
    openGraph: z.record(z.string(), LocalizedOpenGraphMetadataEntrySchema.optional().nullable()).optional().nullable(),
    noIndex: z.record(z.string(), z.boolean().optional().nullable()).optional().nullable(),
    noFollow: z.record(z.string(), z.boolean().optional().nullable()).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
